module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1510-595de1ad5b4224700214374ee3fe7072.png";